import { ReactComponent as CircuitSVG } from '../../images/leftCircuit.svg';
import './circuit.css';

const AnimatedCircuitLeft = () => {
  return (
    <div className="line-wrapper1">
    <div className="svg-container">
      <CircuitSVG />
    </div>
    </div>
  );
};

export default AnimatedCircuitLeft;
